import { Auth } from 'aws-amplify';
import { CognitoUserSession } from 'amazon-cognito-identity-js';
import { SELECTED_COMPANY_ID } from '../constants';

const getUserSession = async (): Promise<{
  token: string;
  selectedCompanyId: number | undefined;
  session: CognitoUserSession;
}> => {
  const session = await Auth.currentSession();
  const accessToken = session.getAccessToken().getJwtToken();

  const selectedCompanyId =
    localStorage.getItem(SELECTED_COMPANY_ID) &&
    !isNaN(Number(localStorage.getItem(SELECTED_COMPANY_ID)))
      ? Number(localStorage.getItem(SELECTED_COMPANY_ID))
      : undefined;

  return {
    token: accessToken,
    selectedCompanyId,
    session
  };
};

export default getUserSession;
